export const productSearchSuggestionQuery = /* GraphQL */ `
    query categories(
        $search: String
        $pageSize: Int = 4
        $currentPage: Int = 0
    ) {
        products(
            search: $search
            pageSize: $pageSize
            currentPage: $currentPage
        ) {
            total_count
            aggregations {
                label

                attribute_code
                options {
                    label
                    value
                    __typename
                }
                __typename
            }

            items {
                __typename
                name
                product_eyebrow_badge
                product_eyebrow_badge_text
                price_range {
                    __typename
                    minimum_price {
                        __typename
                        regular_price {
                            __typename
                            value
                            currency
                        }
                        final_price {
                            __typename
                            value
                            currency
                        }
                        discount {
                            __typename
                            amount_off
                        }
                    }
                    maximum_price {
                        final_price {
                            value
                            currency
                        }
                    }
                }

                small_image {
                    __typename
                    url
                }
                url_key
            }
        }
    }
`
